import { useEffect, useRef } from "react";
import { Bold, Italic, Heading3, List, ListOrdered, Link2, Pilcrow, RemoveFormatting, Quote } from "lucide-react";
import { tx, useLang } from "../../lib/i18n";

const CMDS = [
  ["Heading", Heading3, () => document.execCommand("formatBlock", false, "h3")],
  ["Paragraph", Pilcrow, () => document.execCommand("formatBlock", false, "p")],
  ["Bold", Bold, () => document.execCommand("bold")],
  ["Italic", Italic, () => document.execCommand("italic")],
  ["Bulleted list", List, () => document.execCommand("insertUnorderedList")],
  ["Numbered list", ListOrdered, () => document.execCommand("insertOrderedList")],
  ["Quote", Quote, () => document.execCommand("formatBlock", false, "blockquote")],
  ["Link", Link2, () => { const u = window.prompt(tx("Link address (/policies/terms, https://… or mailto:…)")); if (u) document.execCommand("createLink", false, u); }],
  ["Clear formatting", RemoveFormatting, () => document.execCommand("removeFormat")],
];

export const RichText = ({ value, onChange, testid }) => { useLang();
  const ref = useRef(null);
  useEffect(() => { if (ref.current && ref.current.innerHTML !== value) ref.current.innerHTML = value || ""; }, [value]);
  return (
    <div className="overflow-hidden rounded-xl border border-[var(--mv-border-2)] bg-[var(--mv-bg)] focus-within:border-[var(--mv-teal)]">
      <div className="flex flex-wrap gap-0.5 border-b border-[var(--mv-border)] px-1.5 py-1">
        {CMDS.map(([l, I, fn]) => <button key={l} type="button" title={tx(l)} aria-label={tx(l)} onMouseDown={(e) => { e.preventDefault(); fn(); onChange(ref.current.innerHTML); }}
          className="grid h-7 w-7 place-items-center rounded-md text-[var(--mv-muted)] hover:bg-white/5 hover:text-[var(--mv-teal)]" data-testid={`${testid}-tool-${l.toLowerCase().replace(/\s+/g, "-")}`}><I className="h-3.5 w-3.5" /></button>)}
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning onInput={(e) => onChange(e.currentTarget.innerHTML)} className="mv-prose mv-editor min-h-[120px] px-4 py-3" data-testid={testid} />
    </div>
  );
};
